export const bannerSelector = (state) => state.banner;
